import type { RegionTileFragment } from "../client/generated";
import { getRegionName } from "../types/utils";

type Props = {
  fragment: RegionTileFragment;
  preview: string;
  children?: React.ReactNode;
  onClick: () => void;
};

export function RegionTile({ fragment, preview, children, onClick }: Props) {
  return (
    <div className="flex flex-row items-center p-2">
      <div className="flex-1 overflow-hidden">
        <button
          className="flex flex-row gap-1 items-center"
          type="button"
          onClick={onClick}
        >
          <div className="font-bold flex flex-row gap-1 hover:text-brand">
            {getRegionName(fragment)}
          </div>
        </button>
        <div className="truncate text-xs">{preview}</div>
      </div>
      <div>{children}</div>
    </div>
  );
}
